<template>
  <button id="save">
    <span>{{message}} <font-awesome-icon :icon="icon" class="icon" v-if="!submitting"></font-awesome-icon></span>
     <span v-show="submitting" class="submitting">
      <div class="icon circle-loader">
        <div v-if="this.complete === 'fail' || this.complete === 'validate'" class="close"></div>
        <div v-else class="checkmark draw"></div>
      </div>
    </span>
  </button>
</template>

<script>
export default {
  name: 'save',
  data () {
    return {
      globalSearch: '',
      icon: '',
      message: ''
    }
  },
  created () {
    this.icon = (this.process === 'Standard') ? ['fas', 'save'] : ['fas', 'check-double']
    this.message = (this.process === 'Standard') ? 'Save' : 'Approve'
  },
  props: [
    'submitting',
    'complete',
    'process'
  ],
  computed: {
  },
  watch: {
    complete: {
      deep: true,
      handler (newValue, oldValue) {
        if (newValue === 'success') {
          document.querySelector('.circle-loader').classList.add('load-complete')
          document.querySelector('.checkmark').style.display = 'block'
          document.querySelector('.circle-loader').style.borderColor = '#575656'
        } else if (newValue === 'fail' || newValue === 'validate') {
          document.querySelector('.circle-loader').classList.add('load-complete')
          document.querySelector('.circle-loader').style.borderColor = '#575656'
        }
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
@import '../../less/elements/color.less';
#save{
  background-color: @color-white;
  color: @color-text;
  min-width: 127px;
  position: absolute;
  top: 0;
  right: 0;
  height: 45px;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 0;
  border-top: 0;
  border-bottom: 0;
  border-left: 1px solid @color-border;
  padding: 0 15px;
}
.icon{
  margin-left: 6px;
}
.circle-loader {
  border: 3px solid rgba(0, 0, 0, -0.8);
  border-left-color: @color-text;
  -webkit-animation: loader-spin-data-v-1b87dec6 1.2s infinite linear;
  animation: loader-spin-data-v-1b87dec6 1.2s infinite linear;
  vertical-align: top;
  border-radius: 50%;
  width: 1.3rem;
  height: 1.3rem;
  position: relative;
  pointer-events: none;

}
.load-complete {
  -webkit-animation: none;
  animation: none;
  transition: border 500ms ease-out;
}
.checkmark.error {
  position: absolute;
  height: .8rem;
  width: .4rem;
}
.checkmark.error:before, .checkmark.error:after {
  position: absolute;
  content: ' ';
  height: .8rem;
  width: .4rem;
  background-color: #f00;
}
.checkmark.error:before {
  transform: rotate(45deg);
}
.checkmark.error:after {
  transform: rotate(-45deg);
}
.checkmark {
  display: none;
}
.checkmark.draw:after {
  animation-duration: 800ms;
  animation-timing-function: ease;
  animation-name: checkmark;
  transform: scaleX(-1) rotate(135deg);
}
.checkmark:after {
  opacity: 1;
  height: .8rem;
  width: .4rem;
  -webkit-transform-origin: left top;
  transform-origin: left top;
  border-right: 3px solid @color-text;
  border-top: 3px solid @color-text;
  content: '';
  left: 1px;
  top: .5rem;
  position: absolute;
}
.close {
  position: relative;
  width: 1rem;
  height: 1rem;
}
.close:hover {
  opacity: 1;
}
.close:before, .close:after {
  position: absolute;
  left: 0;
  content: ' ';
  width: 2px;
  background-color: @color-text;
}
.close:before {
  transform: rotate(45deg) translate(11.5px, -7px);
  transform-origin: top;
  animation-duration: 600ms;
  animation-timing-function: ease;
  animation-name: failure;
  height: 14px;
}
.close:after {
  transform: rotate(-45deg) translate(0px, 4.5px);
  transform-origin: top;
  animation-duration: 600ms;
  animation-timing-function: ease;
  animation-name: failure;
  height: 14px;
}

@keyframes loader-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes checkmark {
  0% {
    height: 0;
    width: 0;
    opacity: 1;
  }
  20% {
    height: 0;
    width: .4rem;
    opacity: 1;
  }
  40% {
    height: .8rem;
    width: .4rem;
    opacity: 1;
  }
  100% {
    height: .8rem;
    width: .4rem;
    opacity: 1;
  }
}
@keyframes failure {
  0% {
    height: 0;
    opacity: 1;
  }
  30% {
    height: 2px;
    opacity: 1;
  }
  40% {
    height: 4px;
    opacity: 1;
  }
  50% {
    height: 6px;
    opacity: 1;
  }
  60% {
    height: 8px;
    opacity: 1;
  }
  70% {
    height: 10px;
    opacity: 1;
  }
  80% {
    height: 12px;
    opacity: 1;
  }
  100% {
    height: 14px;
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/foundation/save.vue